import { createContext } from "@lit/context";

export const TableHeaderBackgroundContext = createContext<boolean>("table-header-background");
